import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { enableMatomoTracking } from '../../matomo_script';

type CookieProps = {
    activate: boolean;
};

// Le stockage local n'est pas toujours accessible : navigation privée selon les
// navigateurs, blocage des données de site, contexte iframe restreint. `getItem` et
// `setItem` y lèvent une exception plutôt que de renvoyer null. Non protégés, ils
// laissaient la bannière ouverte sans appliquer la décision du visiteur -- et sur
// `refuseCookies`, sans jamais transmettre le refus à Matomo.
const readConsent = (): string | null => {
    try {
        return localStorage.getItem("cookie");
    } catch {
        // Stockage indisponible : aucune décision connue, la bannière reste affichée.
        return null;
    } // try ... catch
};

const writeConsent = (value: string): void => {
    try {
        localStorage.setItem("cookie", value);
    } catch {
        // Décision non mémorisable : elle s'applique quand même à cette session,
        // la bannière réapparaîtra au prochain chargement.
    } // try ... catch
};

const Cookie = ({ activate }: CookieProps): React.JSX.Element => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(activate);

    useEffect(() => {
        const storedCookie = readConsent();
        if (storedCookie !== null) {
            setIsVisible(false);
            hideBanner();
        }
    }, []);

    const hideBanner = () => {
        const element = document.querySelector('.cookie-banner');
        if (element) {
            element.classList.add('d-none');
          
        }
    };
       
    const acceptCookies = () => {

        writeConsent("true");
        setIsVisible(false);
        hideBanner();
        enableMatomoTracking();
    };

    const refuseCookies = () => {
        writeConsent("false");
        setIsVisible(false);
        hideBanner();
        var _paq = window._paq || [];
        _paq.push(['forgetConsentGiven']);
        _paq.push(['disableCookies']);
        deleteMatomoCookies();
    };
      
    const deleteMatomoCookies = () => {
        const matomoCookies = ['_pk_id', '_pk_ses', '_pk_ref', '_pk_cvar'];
        const domainName = window.location.hostname;
        matomoCookies.forEach((cookieName) => {
            Cookies.remove(cookieName, { path: '/' });
            Cookies.remove(cookieName, { path: '/', domain: domainName });
        });
    };

    return (
        <div className={`cookie-banner ${!isVisible ? 'd-none' : ''}`}>
            <Row>
                <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                    <p>
                        {t('Cookie.Description')}<a href="/cookie">{t('Cookie.Link')}</a>
                    </p>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} xl={4} className="cookie-content-btn">
                    <button className="flowly-btn orange btn btn-primary" onClick={acceptCookies}>
                        {t('Cookie.Accept')}
                    </button>
                    <button className="flowly-btn red btn btn-primary" onClick={refuseCookies}>
                        {t('Cookie.Essential')}
                    </button>
                </Col>
            </Row>
        </div>
    );
};

export default Cookie;

